export enum treasuryPersonalEmailFormFields {
  personalEmail = 'personalEmail',
}
